package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseUp
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.config.transitionBackground
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun TabItem(
    windowSizeMode: WindowSizeModeEnum,
    title: String,
    isSelected: Boolean,
    onTabClick: () -> Unit,
)
{
    val isHovered= remember { mutableStateOf(false) }
    val isFocused= remember{ mutableStateOf(false) }


    Box(
        modifier = Modifier
            .thenIf(
            windowSizeMode!= WindowSizeModeEnum.Desktop,
               Modifier.minWidth(Dimen.tabItemWidth)
            )
            .onClick {
                onTabClick()
            }
            .height(Dimen.userTabHeight)
            .borderRadius(
                topRight = Dimen.lowBorderRadius,
                topLeft = Dimen.lowBorderRadius,
            )
            .cursor(Cursor.Pointer)
            .onMouseEnter { isHovered.value=true}
            .onMouseLeave { isHovered.value=false }
            .onMouseDown {isFocused.value=true}
            .onMouseUp { isFocused.value=false }
            .backgroundColor(
                if (isSelected) {
                        if (isFocused.value) Theme.PrimaryStatesSelected.rgb
                        else if (isHovered.value) Theme.PrimaryStatesHover.rgb
                        else Theme.Transparent.rgb

                }else{
                     if (isFocused.value) Theme.ActionSelected.rgb
                    else  if (isHovered.value) Theme.ActionHover.rgb
                    else Theme.Transparent.rgb
                }
            )
    )
    {
        SpanText(
            text = title,
            modifier = Modifier
                .textAlign(TextAlign.Center)
                .fillMaxWidth()
                .overflowText()
                .align(Alignment.Center)
                .padding(leftRight = Dimen.mediumPadding)
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(FontWeight.Medium)
                .color(
                    when {
                        isSelected -> Theme.PrimaryMain.rgb
                        else -> Theme.TextSecondary.rgb
                    }
                )
                .fontFamily(FontFamily.Jakarta)
        )

        Box(
            modifier = Modifier
                .height(
                    if (isSelected) Dimen.mediumThickness
                    else 0.px
                )
                .transitionBackground()
                .width(100.percent)
                .align(Alignment.BottomCenter)
                .backgroundColor(Theme.PrimaryMain.rgb)

        )

    }


}